import { createSlice, current } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie';
import React from 'react'
import axios from 'axios';
import { URL } from '../../config';
     

     
const initialState={ 
  currentUser: null,
  token:"",
  isLoading:false,
  isLogoutLoading:false,
  modal:false,
  email:"",
  emailError:"",
  otpError:"",
  SignFlag:0
}

export const AuthSlice =  createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    login: (state,action) => {

      state.currentUser=action.payload.user;
      state.token=action.payload.token;
    },
    logout:(state) => {
      state.currentUser=null;
      state.token="";
    },
    getCurrentUser:(state,action)=>{
      state.currentUser=action.payload.user;
      state.token=action.payload.token;
    },
    loadingLogoutChange:(state)=>{
      state.isLogoutLoading=!state.isLogoutLoading;
    },
    loadingChange:(state,action)=>{
      state.isLoading=!state.isLoading;
    },
    modalChange:(state,action)=>{
      state.modal=!state.modal;
    },
    emailChange:(state,action)=>{
      state.email=action.payload;
    },
    otpErrorChange:(state,action)=>{
      state.otpError=action.payload;
    },
    emailErrorChange:(state,action)=>{
      state.emailError=action.payload;
    },
    setSignFlag:(state,action)=>{
      state.SignFlag=action.payload;
    },
    updateCurrentUser:(state,action)=>{
      state.currentUser={...state.currentUser,...action.payload}
    }
  },
})
export const {loadingLogoutChange,updateCurrentUser,modalChange,emailErrorChange,otpErrorChange,login,logout,loadingChange,getCurrentUser,emailChange,setSignFlag}=AuthSlice.actions
export default AuthSlice.reducer